import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ru from 'vuetify/lib/locale/ru';
import {
    Archive,
    BarChart3,
    Calendar,
    CaseSensitive,
    Check,
    Code,
    Eye,
    EyeOff,
    FileImage,
    FileText,
    FileVideo,
    GripVertical,
    Heading1,
    Heading2,
    Image as ImageIcon,
    Images,
    Info,
    KeyRound,
    Link,
    Lock,
    Paperclip,
    Pencil,
    Search,
    Trash2,
    User,
    Video,
    X,
} from 'lucide-vue';

Vue.use(Vuetify);

/**
 * Иконки — Lucide. Подключены как «значения» Vuetify: в разметке пишем `$имя`
 * (например `<v-icon small>$pencil</v-icon>` или `prepend-icon="$calendar"`),
 * поэтому одинаково работают и теги, и свойства компонентов.
 *
 * Размер иконки задаётся в CSS (`.v-icon svg { width: 1em }`, см. App.vue):
 * так v-icon small/large продолжают работать, как со старым набором.
 */
const icons = {
    account: User,
    archive: Archive,
    calendar: Calendar,
    check: Check,
    close: X,
    code: Code,
    delete: Trash2,
    drag: GripVertical,
    eye: Eye,
    'eye-off': EyeOff,
    'file-document': FileText,
    'file-image': FileImage,
    'file-pdf': FileText,
    'file-video': FileVideo,
    'header-1': Heading1,
    'header-2': Heading2,
    image: ImageIcon,
    'image-multiple': Images,
    info: Info,
    'letter-case': CaseSensitive,
    link: Link,
    lock: Lock,
    'lock-field': KeyRound,
    paperclip: Paperclip,
    pencil: Pencil,
    poll: BarChart3,
    search: Search,
    video: Video,
};

export default new Vuetify({
    // Служебные подписи самого Vuetify (постраничная навигация «1-10 из 65»,
    // «Отсутствуют данные», подсказки для скринридеров) — по-русски.
    lang: {
        locales: { ru },
        current: 'ru',
    },
    icons: {
        values: Object.fromEntries(
            Object.entries(icons).map(([name, component]) => [name, { component }])
        ),
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#27394e',     // Темно-синий основной (как шапка/футер)
                secondary: '#42b6ec',   // Светло-голубой
                accent: '#006899',      // Яркий синий
                background: '#f5f7ff',  // Фоновый цвет
                error: '#ff5252',
                info: '#2196f3',
                success: '#4caf50',
                warning: '#ffc107',
            },
        },
    },
});
